import * as React from "react";
import { HFTResults } from "../models/HFTResults";
import { SFT_Targets } from "../models/SFT_Targets";
import { PT_ProtectiveFunction } from "../models/PT_ProtectiveFunction";
import { CalculationResultsView } from "../models/CalculationResultsView";

interface Props {
  sftTargets: SFT_Targets;
  calculationResults: PT_ProtectiveFunction;
  hftResults: HFTResults;
}

const CalculationTable = (props: Props) => {
  const results = new CalculationResultsView(
    props.calculationResults,
    props.hftResults
  )
  const sftTargets = props.sftTargets || new SFT_Targets();
  return (
    <table className="table table-condensed table-borderless" style={{border: "2px solid black"}}>
      <tbody>
        <tr>
          <td></td>
          <th>PFDavg</th>
          <th>IL</th>
          <th>STR<br/>(1/yr)</th>
          <th>MTTFs<br/>(yrs)</th>
          <th>HFT</th>
        </tr>
        <tr>
          <th>Targets</th>
          <td>{sftTargets.xpfDavg}</td>
          <td>{sftTargets.sil}</td>
          <td>{sftTargets.xstR1Year}</td>
          <td>{sftTargets.mttf}</td>
          <td>{sftTargets.hftTarget}</td>
        </tr>
        <tr>
          <th>Results</th>
          <td>{results.pfdAvg}</td>
          <td>{results.sil}</td>
          <td>{results.str}</td>
          <td>{results.mttf}</td>
          <td>{results.hft}</td>
        </tr>
      </tbody>
    </table>
  );
}

export default CalculationTable;
